

import statsBg from '../../assets/images/about-us/stats-bg.webp'
import statsWatchFace from '../../assets/images/about-us/stats-watch-face.webp'
import rafPortrait from '../../assets/images/about-us/raf-portrait.webp'
import showroomPhoto1 from '../../assets/images/about-us/showroom-photo-1.webp'
import watchMacro1 from '../../assets/images/about-us/watch-macro-1.jpg'
import hermesBag1 from '../../assets/images/about-us/hermes-bag-1.jpg'
import watch1 from '../../assets/images/about-us/watch-1.jpg'
import watch2 from '../../assets/images/about-us/watch-2.jpg'
import loungeView from '../../assets/images/about-us/lounge-view.webp'
import showcaseWall from '../../assets/images/about-us/showcase-wall.webp'
import videoPreview from '../../assets/images/about-us/video-preview.webp'
import videoFile from '../../assets/images/about-us/video.mp4'

import "./AboutPage.css";
import Testimonials from '../SellWithUs/Testimonials/Testimonials'
import { useContext, useEffect, useRef, useState } from 'react'
import ContactBlock from './ContactBlock/ContactBlock'
import { ConfigContext } from '../../assets/contexts/configContext'
import PromoScroll from '../Main/Banners/PromoScroll/PromoScroll'
import Stats from './Stats/Stats'

export default function AboutPage() {
    const videoRef = useRef(null);
    const [videoOk, setVideoOk] = useState(true);
    const config = useContext(ConfigContext)
    const { mainLayout, initialConstants } = config
    console.log({ mainLayout: mainLayout ? mainLayout.filter(i => i.type === "promo-banner-scroll") : null })
    // Nudge autoplay on mobile/iOS and when tab becomes visible again
    useEffect(() => {
        const v = videoRef.current;
        if (!v) return;

        const tryPlay = () => {
            v.play().catch(() => {
                // if autoplay blocked for any reason, keep muted and try once more shortly
                setTimeout(() => v.play().catch(() => { }), 250);
            });
        };

        // attempt immediately if metadata is ready, else on canplay
        if (v.readyState >= 2) tryPlay();
        v.addEventListener('canplay', tryPlay, { once: true });

        const onVisibility = () => {
            if (document.visibilityState === 'visible') tryPlay();
        };
        document.addEventListener('visibilitychange', onVisibility);

        return () => {
            v.removeEventListener('canplay', tryPlay);
            document.removeEventListener('visibilitychange', onVisibility);
        };
    }, []);

    return (
        <main className="about">
            {/* ================= HERO ================= */}
            <section className="about__hero">
                <div className="about__hero-media">
                    <div className='about__hero-gradient' />
                    {videoOk ? (
                        <video
                            ref={videoRef}
                            className="about__hero-bg about__hero-video"
                            poster={videoPreview}
                            autoPlay
                            muted
                            playsInline
                            loop
                            preload="auto"
                            controls={false}
                            disablePictureInPicture
                            onError={() => setVideoOk(false)}
                        >
                            <source src={videoFile} type="video/mp4" />
                            {/* If the browser can't play MP4, we'll fall back below */}
                        </video>
                    ) : (
                        <img
                            src={videoPreview}
                            alt="Showroom video cover"
                            className="about__hero-bg"
                        />
                    )}

                    <div className="about__hero-overlay">
                        <p className="about__hero-eyebrow">Дилер роскошных часов</p>
                        <h1 className="about__hero-title">Sany Watches</h1>
                    </div>
                </div>
                <div className="about__brands">
                    {mainLayout && mainLayout.length > 0 && mainLayout.filter(i => i.type === "promo-banner-scroll").length > 0 ?
                        <PromoScroll item={mainLayout.filter(i => i.type === "promo-banner-scroll")[0]} />
                        : null}
                </div>
            </section>


            {/* =============== WELCOME =============== */}
            <section className="about__welcome">
                <div className="about__container">
                    <h2 className="about__welcome-h2">
                        Добро пожаловать в Sany <span>— здесь всё вращается вокруг времени</span>
                    </h2>

                    <div className="about__welcome-grid">
                        <img className="about__welcome-main"
                            src={showroomPhoto1}
                            alt="Showroom"
                        />

                        <div className="about__welcome-right">
                            <p className="about__welcome-lead">
                                Основанная <span>в&nbsp;2014&nbsp;году, Sany появилась из&nbsp;простой, но&nbsp;сильной идеи: поделиться страстью к&nbsp;изысканным часам с&nbsp;миром. То, что начиналось как маленькая мечта, сегодня превратилось в&nbsp;имя, известное любителям часов по&nbsp;всему миру&nbsp;&mdash; место, где объединяются красота, точность и&nbsp;традиции.</span>
                            </p>

                            <div className="about__welcome-thumbs">
                                <img
                                    src={watchMacro1}
                                    alt="Watch macro"
                                    className="about__welcome-thumb"
                                />
                                <img
                                    src={hermesBag1}
                                    alt="Hermes bag"
                                    className="about__welcome-thumb"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* =============== FOUNDER =============== */}
            <section className="about__founder">
                <div className="about__container about__founder-grid">
                    <img className="about__founder-photo"
                        src={rafPortrait}
                        alt="Rafael portrait"
                    />

                    <div className="about__founder-copy">
                        <p className="about__founder-text">
                            Вдохновлённый <span>семейным наследием в&nbsp;ювелирном деле и&nbsp;движимый собственной любовью к&nbsp;часовому искусству, Рафаэль основал Sany, чтобы соединять людей с&nbsp;часами, которые являются чем-то большим, чем аксессуар. Каждая модель выбирается не&nbsp;только за&nbsp;мастерство исполнения, но&nbsp;и&nbsp;за&nbsp;историю, которую она несёт, и&nbsp;эмоции, которые дарит своему владельцу.</span>
                        </p>
                        <div className='about__founder-title'>
                            <h3 className="about__founder-name">РАФАЭЛЬ</h3>
                            <p className="about__founder-role">Основатель Sany</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* =============== WITH (vision) =============== */}
            <section className="about__with">
                <div className="about__container">
                    <div className="about__with-grid">
                        <img className="about__with-card"
                            src={watch1}
                            alt="Luxury bag left"
                        />

                        <div className="about__with-copy">
                            <h3 className="about__with-title">
                                <span className="about__with-title-em">Sany доверяют</span> как коллекционеры, так и&nbsp;те, кто покупает свои первые часы. Мы&nbsp;стали местом притяжения для тех, кто ищет самые редкие бренды и&nbsp;наиболее востребованные модели. Каждые часы, которые мы&nbsp;отбираем, отражают наше убеждение: роскошь должна быть вне времени&nbsp;&mdash; это инвестиция в&nbsp;стиль, индивидуальность и&nbsp;историю, которая живёт дольше своего первого владельца.
                            </h3>
                        </div>

                        <img className="about__with-card"
                            src={watch2}
                            alt="Luxury bag right"
                        />
                    </div>
                </div>
            </section>

            {/* =============== WHAT (story + gallery) =============== */}
            <section className="about__what">
                <div className="about__container">
                    <div className="about__what-top">
                        <div className="about__what-copy">
                            <h3 className="about__what-heading">
                                <span className="about__what-heading-em">Каждые часы</span> рассказывают историю. В&nbsp;Sany мы&nbsp;верим: это больше, чем способ отслеживать время. Это возможность отмечать важные этапы жизни, хранить искусство и&nbsp;наследие. Независимо от&nbsp;того, создаёте&nbsp;ли вы&nbsp;коллекцию или открываете для себя первые часы, наша миссия&nbsp;&mdash; сделать это путешествие незабываемым.
                            </h3>
                            <img className="about__what-photo"
                                src={loungeView}
                                alt="Lounge interior"
                            />
                        </div>

                        <img className="about__what-hero"
                            src={showcaseWall}
                            alt="Showcase wall"
                        />
                    </div>

                </div>
            </section>
            <Testimonials className={'about__reviews'} />
            {/* =============== STATS =============== */}
            <Stats />

            <div className="about__container">
                <ContactBlock />
            </div>

        </main >
    );
}
